// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"5c0db47d","130":"b4bcdab8","720":"b4bcdab8","975":"9ad07ca2"}[chunkId] + ".css";
};